import React from 'react';
import PropTypes from 'prop-types';

import BaseOnOff from '@adsk/bim360-matrix-react-base-on-off';

import './_ToggleButton.scss';

/**
 * @class ToggleButton
 **/
export default class ToggleButton extends BaseOnOff {
  /**
   * @constructor ToggleButton
   **/
  constructor(props) {
    super(props);
  }

  renderInnerComponent() {
    return <span className="ToggleButton__label">{this.props.label}</span>;
  }

  /**
   * render
   */
  render() {
    return super.render('ToggleButton', this.renderInnerComponent.bind(this));
  }
}

ToggleButton.propTypes = {
  ...BaseOnOff.propTypes,
  /**
   * The label for the button to display
   */
  label: PropTypes.string.isRequired
};
